import React, { Fragment, useEffect, useState } from "react";
import {
  Menu,
  MenuButton,
  MenuItems,
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
  MenuItem,
} from "@headlessui/react";
import {
  XMarkIcon,
  BellIcon,
  ChevronRightIcon,
  ArrowLeftIcon,
  BellSnoozeIcon,
} from "@heroicons/react/24/outline";
import { notificationConfigs } from "../../../utils/notificationConfigs";
import { LoadMoreNotifications } from "../../notifications/partials/LoadMoreNotifications";
import { EmptyNotifications } from "../../notifications/partials/EmptyNotifications";
import { LoaderPagination } from "../../notifications/partials/LoaderPagination";

export function DisclosureBell({
  noti,
  iconEffect,
  handleUpdateReadNotification,
  handleLoadMoreNotifications,
  isLoading,
  hasMore,
  handleBulkUpdateNotification,
}) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div
        className={"w-full"}
        onClick={() => {
          setOpen(true);
          handleBulkUpdateNotification();
        }}
        href="#"
      >
        <div className="cursor-pointer min-w-full">
          <div className="flex justify-between">
            <div className="flex gap-2 py-1">
              <div className="w-5 h-auto">
                <BellIcon style={{ cursor: "pointer" }} />{" "}
              </div>
              <div>Notificaciones</div>
            </div>
            <div className="grid content-center">
              <ChevronRightIcon className="w-5 h-auto" />
            </div>
          </div>
        </div>
      </div>
      <Dialog open={open} onClose={setOpen} className="relative z-50">
        <DialogBackdrop
          transition
          className="fixed inset-0 transition-opacity duration-200 ease-in-out data-closed:opacity-0"
        />

        <div className="fixed inset-x-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full md:pl-10">
              <DialogPanel
                transition
                className="pointer-events-auto w-screen md:max-w-sm transform transition duration-300 ease-in-out data-closed:translate-x-full"
              >
                <div className="flex h-full flex-col bg-darkBg tracking-tight font-walsheim">
                  <div>
                    <div className="py-6 bg-darkBg">
                      <div className="flex justify-between px-4 pt-8 ">
                        <div className="flex h-7 items-center">
                          <button
                            type="button"
                            onClick={() => setOpen(false)}
                            className="relative text-white focus:outline-hidden"
                          >
                            <span className="absolute" />
                            <span className="sr-only">Close panel</span>
                            <ArrowLeftIcon
                              aria-hidden="true"
                              className="h-6 w-6"
                            />
                          </button>
                        </div>
                        <DialogTitle>
                          <div className="text-white">Notificaciones</div>
                        </DialogTitle>
                        <div className="ml-3 flex h-7 items-center">
                          <button
                            type="button"
                            onClick={() => setOpen(false)}
                            className="relative text-white focus:outline-hidden"
                          >
                            <span className="absolute" />
                            <span className="sr-only">Close panel</span>
                            <XMarkIcon aria-hidden="true" className="h-6 w-6" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="h-full overflow-y-scroll rounded-t-3xl bg-white">
                    <div>
                      {noti.length > 0 ? (
                        <Fragment>
                          <div className="overflow-y-auto">
                            {(noti ?? []).map((notification, idx) => (
                              <div
                                key={notification.id}
                                className={`${!notification.read ? "bg-purpleLight font-bold" : ""}`}
                              >
                                <a
                                  onClick={() => {
                                    handleUpdateReadNotification(
                                      notification.id,
                                      !notification.read,
                                      notification?.type,
                                    );
                                    console.log(notification?.type);
                                  }}
                                  key={idx}
                                  href={notification.href}
                                  className="group flex w-full items-center gap-2 rounded-md px-4 py-4"
                                >
                                  <div className="block">
                                    <div className="w-5 h-5">
                                      {notification.icon}
                                    </div>
                                  </div>
                                  <div className="pr-1 pl-2">
                                    <span className="inline-block">
                                      {notification.description}
                                      <span className="pl-2 text-grayP">
                                        {notification.time}
                                      </span>
                                    </span>
                                  </div>
                                </a>
                                <hr className="border-t text-grayM"></hr>
                              </div>
                            ))}
                          </div>

                          {isLoading ? (
                            <LoaderPagination />
                          ) : hasMore === false ? (
                            <EmptyNotifications />
                          ) : (noti ?? []).length >=
                            notificationConfigs.initNotificationsRows ? (
                            <LoadMoreNotifications
                              handleLoadMoreNotifications={
                                handleLoadMoreNotifications
                              }
                            />
                          ) : (
                            <></>
                          )}
                        </Fragment>
                      ) : (
                        <>
                          <div className="text-grayP text-sm flex justify-center py-4">
                            <div>
                              <div className="flex justify-center">
                                <BellSnoozeIcon className="w-4 h-auto" />
                              </div>
                              No tienes notificaciones.
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </DialogPanel>
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
}

export function MenuBell({
  noti,
  handleUpdateReadNotification,
  handleLoadMoreNotifications,
  isLoading,
  hasMore,
  handleBulkUpdateNotification,
}) {
  return (
    <Menu>
      {({ open }) => (
        <MenuBellContent
          open={open}
          noti={noti}
          handleUpdateReadNotification={handleUpdateReadNotification}
          handleLoadMoreNotifications={handleLoadMoreNotifications}
          isLoading={isLoading}
          hasMore={hasMore}
          handleBulkUpdateNotification={handleBulkUpdateNotification}
        />
      )}
    </Menu>
  );
}

function MenuBellContent({
  open,
  noti,
  handleUpdateReadNotification,
  handleLoadMoreNotifications,
  isLoading,
  hasMore,
  handleBulkUpdateNotification,
}) {
  useEffect(() => {
    if (open) {
      handleBulkUpdateNotification();
    }
  }, [open, handleBulkUpdateNotification]);

  return (
    <>
      <MenuButton>
        <BellIcon className={`w-6 h-auto`} style={{ cursor: "pointer" }} />
      </MenuButton>
      <MenuItems
        transition
        anchor="bottom end"
        className="w-96 h-120 overflow-scroll shadow-xl origin-top-right font-walsheim tracking-tight rounded-xl text-sm bg-white py-5 text-tdark transition duration-100 ease-out data-closed:scale-95 data-closed:opacity-0"
      >
        <div className="h-full max-h-40">
          <div className="font-bold text-grayP pb-2 px-4">Notificaciones</div>

          {noti.length > 0 ? (
            <Fragment>
              <div className="h-100 overflow-y-auto">
                {noti.map((notification, i) => (
                  <Fragment key={"fragment-notification-" + i}>
                    <MenuItem key={"menu-notification-" + i}>
                      <div
                        key={"div-notification-" + i}
                        className={`${!notification.read ? "bg-purpleLight font-bold" : ""}`}
                      >
                        <hr
                          key={"hr-notification-" + i}
                          className="border-t text-grayM"
                        ></hr>
                        <a
                          key={"a-notification-" + i}
                          onClick={() => {
                            handleUpdateReadNotification(
                              notification.id,
                              !notification.read,
                              notification?.type,
                            );
                            console.log(notification?.type);
                          }}
                          href={notification.href}
                          className="group flex w-full items-center gap-2 rounded-md px-4 py-4"
                        >
                          <div
                            className="block"
                            key={"div-notification-icon-" + i}
                          >
                            <div
                              className="w-5 h-5"
                              key={"div-notification-icon-" + i}
                            >
                              {notification.icon}
                            </div>
                          </div>
                          <div
                            className="pr-1"
                            key={"div-notification-description-" + i}
                          >
                            <span
                              className="inline-block"
                              key={"span-notification-description-" + i}
                            >
                              {notification.description}
                              <span
                                className="pl-2 text-grayP"
                                key={"span-notification-time-" + i}
                              >
                                {notification.time}
                              </span>
                            </span>
                          </div>
                        </a>
                      </div>
                    </MenuItem>
                  </Fragment>
                ))}
              </div>

              {isLoading ? (
                <LoaderPagination />
              ) : hasMore === false ? (
                <EmptyNotifications />
              ) : (noti ?? []).length >=
                notificationConfigs.initNotificationsRows ? (
                <LoadMoreNotifications
                  handleLoadMoreNotifications={handleLoadMoreNotifications}
                />
              ) : (
                <></>
              )}
            </Fragment>
          ) : (
            <>
              <div className="text-grayP text-sm flex justify-center py-4">
                <div>
                  <div className="flex justify-center">
                    <BellSnoozeIcon className="w-4 h-auto" />
                  </div>
                  No tienes notificaciones.
                </div>
              </div>
            </>
          )}
        </div>
      </MenuItems>
    </>
  );
}
